<template>
	<div class="fruitefaceguide">
		<Loading msg="loading" v-if="!isload" />
		<div class="fruit_face_guide_inner" v-else>
            <div class="guide_title">你知道吗?</div>
            <p class="guide_text">你现在的“水果脸”<br>50%是由<strong>基因</strong>决定的<br>它影响了你的<br>美白、衰老、敏感和痘痘等问题</p>
            <img src="../assets/images/fruit_face_guide_poster.png" class="guide_poster" alt="">
            <p class="guide_text_2nd">不了解自己肌肤基因<br>50%的护肤品<br>都是在试错</p>
            <div class="guide_btn" @click="show_2nd=true">如何避免</div>
		</div>
        <!-- 引导第二页 -->
        <div class="guide_2nd_page" v-show="show_2nd">
            <div class="second_page_title"><span>肌肤分子检测&nbsp;轻享版</span></div>
            <div class="second_apge_title_next">UNISKIN测肤小白盒</div>
            <div class="second_page_tip">检测你的基因能力，帮你:</div>
            <ul class="explain_list">
                <li class="explain_text">找准先天优劣势,确定护肤重点</li>
                <li class="explain_text">匹配合适自己的功效成分</li>
                <li class="explain_text">选择最适合你的护肤品</li>
                <li class="explain_text">随时询问最懂你皮肤的咨询师</li>
            </ul>
            <div class="second_page_check_btn"><span class="btn_discount" @click="$parent.routerGo('/offlineactivity')">优惠购买</span><span class="btn_example" @click="$parent.linkGo('https://www.uniskin.com.cn/homepage/reportv3_permission/reportExampleEntry.html')">体验示例报告</span></div>
        </div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
// import sensors from "sa-sdk-javascript";
var wx = require("weixin-js-sdk");

export default {
  name: "FruitFaceGuide",
  data() {
    return {
      isload: true,
      show_2nd:false,   //展示引导第二页
      in_weapp: false //是否在小程序
    };
  },

  created() {
    console.log("FruitFaceGuide created", this);
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
    document.querySelector('.expert_consultant').style.display='none';
    if(location.href.indexOf('fromfruitface') > -1){
      that.back_btn_text = "BACK";
      // sensors.track('reportEvent',{is_access:true,page_id:'477',page_name:'水果脸页面-跳转线下落地页',report_type:'水果脸',first_module:'水果脸'});
      window.linkflow.sendEvent({"reportEvent":{is_access:true,reportEvent_page_id:'477',reportEvent_page_name:'水果脸页面-跳转线下落地页',reportEvent_report_type:'水果脸',reportEvent_first_module:'水果脸'}});
    }else{
      that.back_btn_text = "HOME";
    }
     
  },
  methods: {
      goHome: function(){
        if(location.href.indexOf('fromfruitface') > -1){   //来源为水果脸 则返回历史  否则跳转到商城
           window.history.go(-1);
        }else{
            if (this.in_weapp) {
            wx.miniProgram.switchTab({
              url: "/mall/mall"
            });
          } else {
            location.href =
              "https://www.uniskin.com.cn/homepage/m/shop.html";
          }
        }

    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.fruit_face_guide_inner{
    box-sizing:border-box;
    -webkit-overflow-y:scroll;
    overflow-y:scroll;
    position:fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background:#FFFAF1;
    padding:81/50rem 30/50rem 131/50rem;
    text-align:center;
    .guide_title{
        text-align:center;
        font-size:38/50rem;
        line-height:1em;
        color:#ff6010;
        font-weight:bold;
        padding-bottom:34/50rem;
    }
    .guide_text{
        font-size:32/50rem;
        line-height:50/50rem;
        color:#ff9c6b;   
        text-align:center;
        padding-bottom:34/50rem;
    }
    .guide_poster{
        width:100%;
    }
    .guide_text_2nd{
        font-size:38/50rem;
        line-height:56/50rem;
        color:#ff6010;
        padding:40/50rem 0 46/50rem;
        text-align:center;
    }
    .guide_btn{
        margin:0 auto;
        width:297/50rem;
        height:84/50rem;
        .border-radius(42/50rem);
        .gradient(to right,#FFA471,#FF6010);
        font-size:32/50rem;
        line-height:84/50rem;
        text-align:center;
        color:#fff;
    }

}
.guide_2nd_page{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:#FFFAF1;
    box-sizing:border-box;
    padding:120/50rem 30/50rem 136/50rem;
    .second_page_title{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-center;
        span{
            .align-self_center;
            padding:0 20/50rem;
            font-size:38/50rem;
            line-height:1em;
            color:#000;
        }
        &::after,&::before{
            .align-self_center;
            content:"";
            display:block;
            width:10px;
            height:10px;
            .border-radius(50%);
            -webkit-transform:scale(0.5);
            transform:scale(0.5);
            background:#000;
        }
    }
    .second_apge_title_next{
        padding:19/50rem 0 97/50rem;
        text-align:center;
        font-size:48/50rem;
        line-height:1em;
        color:#ff6010;
        font-weight:bold;
    }
    .second_page_tip{
        padding-bottom:40/50rem;
        font-size:32/50rem;
        line-height:1em;
        color:#333;
    }
    .explain_list{
        .border-radius(14/50rem);
        .shadow;
        background:#fff;
        box-sizing:border-box;
        padding:52/50rem 0 74/50rem 47/50rem;
        margin-bottom:165/50rem;
        .explain_text{
            position:relative;
            padding:25/50rem 0 25/50rem 89/50rem; 
            font-size:38/50rem;
            line-height:1em;
            font-weight:bold;
            color:#ff9c6b;
            &::before{
                content:"";
                display:block;
                width:65/50rem;
                height:60/50rem;
                background:url("../assets/images/fruite_face_guide_check_icon.png") no-repeat 0 0;
                background-size:100%;
                position:absolute;
                left:0;
                top:50%;
                transform:translateY(-50%);
            }
        }
    }
    .second_page_check_btn{
        box-sizing:border-box;
        padding:0 22/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-justify;
        span{
            width:300/50rem;
            height:84/50rem;
            line-height:84/50rem;
            font-size:32/50rem;
            text-align:center;
            .border-radius(42/50rem);
            &.btn_discount{
                color:#fff;
                .gradient(to right,#FFA471,#FF6010);
            }
            &.btn_example{
                color:#ff6010;
                border:1px solid #ff6010;
            }
        }
    }
}
</style>
